import { render, staticRenderFns } from "./InterfaceServiceTerms.vue?vue&type=template&id=099d5fea&scoped=true&"
import script from "./InterfaceServiceTerms.vue?vue&type=script&lang=js&"
export * from "./InterfaceServiceTerms.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceServiceTerms.vue?vue&type=style&index=0&id=099d5fea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099d5fea",
  null
  
)

export default component.exports